import { render, staticRenderFns } from "./DeleteAutoAssignRule.vue?vue&type=template&id=a4611c90&"
import script from "./DeleteAutoAssignRule.vue?vue&type=script&lang=js&"
export * from "./DeleteAutoAssignRule.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAutoAssignRule.vue?vue&type=style&index=0&id=a4611c90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports